export function issueCommentAnchor(commentId: string, anchorPrefix?: string): string {
  return `${anchorPrefix ?? ''}issuecomment-${commentId}`
}

export function reviewSummaryAnchor(reviewId: string, anchorPrefix?: string): string {
  return `${anchorPrefix ?? ''}pullrequestreview-${reviewId}`
}

export function threadCommentAnchorPrefix(anchorPrefix?: string): string {
  // Beats me why there is an r here, but it's consistent with the old Rails implementation
  return `${anchorPrefix ?? ''}discussion-r`
}
